export default {
  en: {
    'bundles-login-components.reset-password-panel.title': 'Reset Password',
  },
};
